import { container, title } from "assets/jss/material-kit-react.jsx";

const landingPageStyle = {
  container: {
    ...container,
    zIndex: "12",
    color: "#f8f8ff",
    paddingLeft: "30px",
    paddingTop: "50px",
    "&:before": {
      background: "linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))",
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "11",
      width: "100%",
      height: "10%",
      display: "block",
      content: "''",
      top: "0",
      left: "0"
    },
  },
  greyBackground: {
    backgroundColor: "#e5e5e5"
  },
  gridContainerItem: {
    textShadow: "1px 1px 2px black",
  },
  inlineBlock: {
    display: "inline-block",
  },
  block: {
    display: "block"
  },
  sectionTitle: {
    ...title,
    textAlign: "left",
    color: "white",
    backgroundColor: "linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))",
    marginBottom: "0px",
    marginTop: "-20vh",
    minHeight: "10vh",
    textDecoration: "none",
    padding: "10px 30px",
    marginLeft: "0px",
    marginRight: "0px",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      padding: "20px 100px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#f8f8ff",
    textDecoration: "none"
  },
  subtitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    maxWidth: "500px",
    margin: "0px",
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  mainRaised: {
    margin: "-60px 30px 0px 30px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  brandNameLarge: {
    textAlign: "center",
    fontSize: "1.5rem",
    lineHeight: "1rem",
    marginBottom: "0px",
    fontWeight: "500",
    textShadow: "none",
    "@media (min-width: 360px)": {
      fontSize: "2rem",
      lineHeight: "1.2rem",
    },
    "@media (min-width: 500px)": {
      fontSize: "3rem",
      lineHeight: "1.7rem",
    },
    "@media (min-width: 600)": {
      fontSize: "3.5rem",
      lineHeight: "2rem",
    },
    "@media (min-width: 768px)": {
      fontSize: "3.5rem",
      lineHeight: "2rem",
    },
    "@media (min-width: 960px)": {
      fontSize: "4rem",
      lineHeight: "2.2rem",
    },
    "@media (min-width: 995px)": {
      fontSize: "5rem",
      lineHeight: "2.7rem",
    },
    "@media (min-width: 1280px)": {
      fontSize: "5.5rem",
      lineHeight: "3rem",
    }
  },
  brandSloganLarge: {
    color: "white",
    textAlign: "center",
    marginTop: "0px",
    fontSize: "63%",
    fontWeight: "500",
    textShadow: "none",
    "@media (min-width: 600px)": {
    },
    "@media (min-width: 768px)": {
      paddingLeft: "0.5rem"
    },
    "@media (min-width: 960px)": {
    },
    "@media (min-width: 1280px)": {
    }
  },
  productLogo:{
    width: "auto", 
    height: "auto",
    margin: "auto",
    borderRadius: "0px",
    "@media (min-width: 600px)": {
    },
    "@media (min-width: 960px)": {
    },
    "@media (min-width: 1280px)": {
    }
  },
  productBrand: {
    textAlign: "center",
    "@media (min-width: 600px)": {
    },
    "@media (min-width: 960px)": {
    },
    "@media (min-width: 1280px)": {
      textAlign: "left"
    }
  },
  athenaLogo: {
  },
  athenaBrandLarge: {
    fontSize: "5rem",
    lineHeight: "1rem",
    paddingTop: "30px",
    "@media (min-width: 350px)": {

    },
    "@media (min-width: 600px)": {
      fontSize: "6rem",
      lineHeight: "1.15rem",
    },
    "@media (min-width: 960px)": {
      fontSize: "7rem",
      lineHeight: "1.3rem",
    },
    "@media (min-width: 1280px)": {
      fontSize: "8rem",
      lineHeight: "1.7rem",
      paddingTop: "0px",
    }
  },
  athenaSloganLarge: {
    color: "white",
    fontSize: "17.2%",
    paddingLeft: "0.2rem",
    "@media (min-width: 600px)": {
    },
    "@media (min-width: 960px)": {
    },
    "@media (min-width: 1280px)": {
      fontSize: "17.5%",
    }
  },
  votingFundsLogo: {
    transform: "rotate(180deg)",
    marginBottom: "3.5%",
    "@media (min-width: 600px)": {
    },
    "@media (min-width: 960px)": {
    },
    "@media (min-width: 1280px)": {
      marginBottom: "auto"
    }
  },
  votingFundsBrandLarge: {
    fontSize: "2rem",
    lineHeight: "1rem",
    "@media (min-width: 340px)": {
      fontSize: "3.5rem",
      lineHeight: "1.9rem",
    },
    "@media (min-width: 600px)": {
      fontSize: "5rem",
      lineHeight: "2.5rem"
    },
    "@media (min-width: 960px)": {
      fontSize: "5.5rem",
      lineHeight: "2.75rem",
    },
    "@media (min-width: 1280px)": {
      fontSize: "7rem",
      lineHeight: "3.5rem",
    }
  },
  votingFundsSloganLarge: {
    color: "white",
    fontSize: "31%",
    lineHeight: "0.3rem",
    paddingLeft: "0.1rem",
  },
  productHeaderHeroCard: {
    paddingBottom: "0px"
  },
  sup: {
    fontSize: "50%"
  },
  noGutter: {
    paddingLeft: "0px",
    paddingRight: "0px"
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.4)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "-1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  waitlistBar: {
    width: "100%",
    textAlign: "right",
    color: "#A51CBE",
    "@media (min-width: 600px)": {
      textAlign: "center"
    },
  }
};

export default landingPageStyle;
